export default __webpack_public_path__ + "static/banner-finance-here-comes-christmas-ce922043b89b9a2262edf7cadd391ae0.jpg";